import React, { useState, useEffect } from "react";
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Badge, Typography } from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchEligibleChatUsers } from "../features/chatRedux/chatAction";

const EligibleChatUsers = ({ currentUserId, onSelectUser }) => {
  const { eligibleUsers = [], onlineUsers = [], loading = false } = useSelector(state => state.chat ||{});

  const dispatch = useDispatch();

  // DEBUG: Log online users
  useEffect(() => {
    console.log("🟢 Online Users:", onlineUsers);
    console.log("📋 Eligible Users:", eligibleUsers.map(u => ({ id: u.userId, name: u.firstName })));
  }, [onlineUsers, eligibleUsers]);

  if (loading) {
    return (
      <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>
        Loading eligible users...
      </div>
    );
  }

  return (
    <div style={{ padding: 16 }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 2, color: '#C3937C' }}>
        Eligible Chat Partners ({eligibleUsers.length})
      </Typography>

      {eligibleUsers.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#999', padding: 40 }}>
          <Typography>No mutual favorations yet.</Typography>
          <Typography variant="body2">Favorate someone to start chatting!</Typography>
        </div>
      ) : (
        <List sx={{ height: 400, overflow: 'auto' }}>
          {eligibleUsers.map((user) => (
            <ListItem
              key={user.userId}
              button
              onClick={() => onSelectUser(user)}
              sx={{
                cursor: 'pointer',
                '&:hover': { bgcolor: '#f5f5f5' },
                mb: 1,
                borderRadius: 1
              }}
            >
              <ListItemAvatar>
                {/* Enhanced Large Online Badge */}
                <Badge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant="dot"
                  color={onlineUsers.includes(String(user.userId)) ? 'success' : 'default'}
                  sx={{
                    '& .MuiBadge-badge': {
                      width: 14,        // Larger dot (14px)
                      height: 14,
                      minWidth: 14,
                      borderRadius: '50%',
                      border: '2px solid white',  // White ring
                      boxShadow: onlineUsers.includes(String(user.userId)) 
                        ? '0 0 8px rgba(76, 175, 80, 0.6)'  // Green glow
                        : 'none',
                      fontSize: '0.75rem',
                      animation: onlineUsers.includes(String(user.userId)) 
                        ? 'pulse 2s infinite' 
                        : 'none'
                    }
                  }}
                >
                  <Avatar sx={{ width: 44, height: 44 }}>
                    {(user.firstName || "")
                      .charAt(0)
                      .toUpperCase()}
                  </Avatar>
                </Badge>
              </ListItemAvatar>
              
              <ListItemText
                primary={
                  <Typography variant="body1" fontWeight="medium">
                    {`${user.firstName} ${user.lastName || ""}`}
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" color="text.secondary">
                    Mutual favoration ✓
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );
};

export default EligibleChatUsers;
